import React from 'react';
import './Footer.css';
import LogoImage from "./LogoImage";

const Footer: React.FC = () => {
    return (
        <div className="footerContainer">
            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-section">
                        <LogoImage />
                        <p>Burggasse 121/34</p>
                        <p>A-1070 Vienna</p>
                        <p>office@oeppe.com</p>
                    </div>
                    <div className="footer-section">
                        <h4>Follow Us</h4>
                        <p>Facebook</p>
                        <p>LinkedIn</p>
                    </div>
                    <div className="footer-section">
                        <h4><a href={"/aichef/privacy-policy"}>Privacy Policy</a></h4>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© 2024 by Oeppe GmbH.</p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
